<template>
    <clients-section title="They Chose Us|Ils nous ont choisis">
        <client-card src="img/clients-color/restauration/arouch.png">
            Arouch
        </client-card>
        <client-card src="img/clients-color/restauration/mc_cafe.png" bg>
            McCafe
        </client-card>
        <client-card src="img/clients-color/restauration/mc_donalds.jpg">
            McDonald's
        </client-card>
        <client-card src="img/clients-color/restauration/mty.png">
            MTY
        </client-card>
        <client-card src="img/clients-color/restauration/second-cup.png" bg>
            Second Cup
        </client-card>
        <client-card src="img/clients-color/restauration/mty-cultures.png" bg>
            Cultures
        </client-card>
        <client-card src="img/clients-color/restauration/client_coq_frit.jpg">
            Le Coq Frit
        </client-card>
        <client-card src="img/clients-color/restauration/double_pizza.png">
            Double Pizza
        </client-card>
        <client-card src="img/clients-color/restauration/koryo.png">
            Koryo
        </client-card>
        <client-card src="img/clients-color/restauration/roaster.png">
            Roaster
        </client-card>
        <client-card src="img/clients-color/restauration/subway.png" bg>
            Subway
        </client-card>
        <client-card src="img/clients-color/restauration/tcby.png">
            TCBY
        </client-card>
        <client-card src="img/clients-color/restauration/thai_express.png">
            Thai Express
        </client-card>
        <client-card src="img/clients-color/restauration/van_houtte.png" bg>
            Van Houtte
        </client-card>
        <client-card src="img/clients-color/restauration/villa_madina.png">
            Villa Madina
        </client-card>
    </clients-section>
</template>

<script>

import ClientCard from "@/components/client-card.vue";
import ClientsSection from "@/components/clients-section.vue";
export default {
    name: `wifi-restauration-client-card`,
    components: {ClientCard, ClientsSection},
    data() {
        return {
            altPrefix: this.tr(`Restauration and bar client guest wifi|Client bar et restaurant wifi social`)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
